import { create } from 'zustand'
import type { Notification } from '../api/notifications'

interface NotificationsState {
  notifications: Notification[]
  unreadCount: number
  setNotifications: (list: Notification[]) => void
  addNotification: (n: Notification) => void
  markRead: (id: string) => void
  markAllRead: () => void
}

export const useNotificationsStore = create<NotificationsState>((set) => ({
  notifications: [],
  unreadCount: 0,
  setNotifications: (list) =>
    set({ notifications: list, unreadCount: list.filter(n => !n.isRead).length }),
  addNotification: (n) =>
    set((s) => ({
      notifications: [n, ...s.notifications],
      unreadCount: s.unreadCount + (n.isRead ? 0 : 1),
    })),
  markRead: (id) =>
    set((s) => ({
      notifications: s.notifications.map(n => n.id === id ? { ...n, isRead: true } : n),
      unreadCount: Math.max(0, s.unreadCount - (s.notifications.find(n => n.id === id)?.isRead ? 0 : 1)),
    })),
  markAllRead: () =>
    set((s) => ({
      notifications: s.notifications.map(n => ({ ...n, isRead: true })),
      unreadCount: 0,
    })),
}))
